import { apiFetch } from './api';

export type Notificacao = {
  id: string;
  tipo: string;
  titulo: string;
  mensagem: string;
  link: string | null;
  lida: boolean;
  criadaEm: string;
};

export const listNotifications = (unread?: boolean) =>
  apiFetch<Notificacao[]>(`/notifications${unread ? '?unread=true' : ''}`);

export const markRead = (id: string) =>
  apiFetch<void>(`/notifications/${id}/read`, { method: 'POST' });

export const markAllRead = () =>
  apiFetch<{ atualizadas: number }>(`/notifications/read-all`, { method: 'POST' });

export const broadcast = (data: {
  tipo: string;
  titulo: string;
  mensagem: string;
  link?: string;
  usuariosIds?: string[];
}) => apiFetch<{ enviadas: number }>(`/notifications/broadcast`, {
  method: 'POST',
  body: JSON.stringify(data),
});
